import React, { useState, ChangeEvent, KeyboardEvent } from 'react';

interface ComboBoxWithInputProps {
  id: string;
  companyNameList: string[];
  value: string;
  setSelectedCompany: (value: string) => void;
}

const ComboBoxWithInput: React.FC<ComboBoxWithInputProps> = ({
  id,
  companyNameList,
  value,
  setSelectedCompany,
}) => {
  const [query, setQuery] = useState<string>(value);
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setQuery(inputValue);
    setSelectedCompany(inputValue);

    if (inputValue) {
      const matches = companyNameList.filter(item =>
        item.toLowerCase().startsWith(inputValue.toLowerCase()),
      );
      setFilteredOptions(matches);
      setShowDropdown(matches.length > 0);
    } else {
      setShowDropdown(false);
    }
  };

  const handleOptionClick = (option: string) => {
    setQuery(option);
    setSelectedCompany(option);
    setShowDropdown(false);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Tab' && filteredOptions.length > 0) {
      e.preventDefault();
      setQuery(filteredOptions[0]);
      setSelectedCompany(filteredOptions[0]);
      setShowDropdown(false);
    }
  };

  return (
    <div className='relative'>
      <input
        id={id}
        type='text'
        value={query}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        required
        className='w-full rounded-xl bg-white py-1.5 pr-8 pl-3 text-sm text-black focus:outline-none focus:ring-2 focus:ring-blue-500'
      />
      {showDropdown && (
        <div className='absolute left-0 w-full mt-1 max-h-60 overflow-auto rounded-xl border border-gray-300 bg-white shadow-lg z-10'>
          <p className='px-4 py-2 text-sm text-gray-700 bg-gray-100 border-b border-gray-300'>
            Diese Unternehmen sind bereits vorhanden. <br />
            Klicken Sie auf den Namen, wenn Sie diesem Unternehmen angehören.
          </p>
          <ul>
            {filteredOptions.map(item => (
              <button
                key={item}
                type='button'
                onClick={() => handleOptionClick(item)}
                className='w-full text-left cursor-pointer select-none py-2 px-4 text-sm text-gray-700 hover:bg-gray-100'
              >
                {item}
              </button>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ComboBoxWithInput;
